import { createReducer } from "@reduxjs/toolkit";
import { SHOW_USER_ALERT, REMOVE_USER_ALERT } from "actions/types";

const initialState = {
  alerts: [],
};
const alertReducer = createReducer(initialState, {
  [SHOW_USER_ALERT]: (state, action) => {
    state.alerts.push(action.payload);
  },
  [REMOVE_USER_ALERT]: (state, action) => {
    const alertIndexToRemove = state.alerts.findIndex(
      (alert) => alert.id === action.payload
    );
    if (alertIndexToRemove !== -1) {
      state.alerts.splice(alertIndexToRemove, 1);
    }
  },
});

export default alertReducer;
